import React, { useCallback, useContext, useState } from 'react'
import { ParentContext } from '../ParentContext';
import { AppUserContext } from '../AppUserContext';
import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths';
import { convertSnapshot } from '../contextHelpers';
import { _globalTicketingName } from 'projectSpecific/ticketing/cnr/reducers/TicketingReducer';
import _ from 'lodash';
import { TriMenu } from 'global/components/menus/TriMenu';

const _useTicketingSubCollection = false

export const useTicketing = () => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { currentSettings_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { database_fns } = fns ?? {}
  let { willCall: _willCallKey } = pathViews ?? {}

  const appUserContext = useContext(AppUserContext);
  const { appUser_state } = appUserContext ?? {}
  const { appUser } = appUser_state ?? {}

  const { appTicketing } = aps_global ?? {}
  const { ticketingCollectionName } = appTicketing ?? {}

  const [tickets, setTickets] = useState({})
  const [allTicketsAlt, setAllTicketsAlt] = useState({})
  const [allTickets, setAllTickets] = useState({})
  const [updating, setUpdating] = useState()

  const getTickets = useCallback(async () => {
    if (ticketingCollectionName) {
      database_fns.get_data_any({ pathViews, collectionName: ticketingCollectionName, callback: setTickets })
      getTicketing(database_fns, pathViews, setAllTickets, setAllTicketsAlt)
    }
  }, []);

  const updateTicket = useCallback(async ({ assignedTickets, ticketKey, subTicketKey, registrationId, credit }) => {
    if (ticketingCollectionName) {
      const cb = () => { setUpdating() }
      setUpdating(true)
      const _assignedTickets = _.cloneDeep(assignedTickets)
      const subTickets = _assignedTickets?.[ticketKey]?.userTickets?.[registrationId]?.subTickets
      const subTicketIndex = _.findIndex(subTickets, { subTicketKey })
      subTickets[subTicketIndex].entered = credit ? false : true
      const _ref = createRefPath_event(pathViews, [_globalTicketingName, ticketKey])
      const dataToUpdate = {
        [`userTickets.${registrationId}.subTickets`]: subTickets
      }
      database_fns.update_doc(_ref, dataToUpdate, cb)
    }
  }, []);

  const getWillCallTickets = useCallback(async () => {
    if (ticketingCollectionName) {

      const { appUserAccess, phoneNumber: phoneNumber_appUser, email: email_appUser } = appUser ?? {}
      let { willCall: _willCallKey } = pathViews ?? {}

      // if the willCallKey is not in the pathView, assign it by the auth email or phoneNumber
      if (!_willCallKey) {
        switch (willCallType) {
          case willCallTypes.email:
            if (email_appUser) { _willCallKey = email_appUser }
            break;
          case willCallTypes.phone:
            if (phoneNumber_appUser) { _willCallKey = phoneNumber_appUser }
            break;
          default:
            break;
        }
      }

      database_fns.get_data_any({ pathViews, collectionName: ticketingCollectionName, callback: setTickets })
      getTicketing(database_fns, pathViews, setAllTickets, setAllTicketsAlt)

      // if (_willCallKey && tickets && groupedWillCalls) {
      //   ticketing_handlers.handleGetWillCallByKey(_willCallKey, pathViews.willCall)
      // }

    }
  }, []);

  const updateAppUserTicket = useCallback(async ({ ticketKey, registrationId, allotment, currentAllotment, subTickets }) => {
    if (ticketingCollectionName) {
      const cb = () => { setUpdating() }
      setUpdating(true)
      const _allotment = currentAllotment - allotment
      const subTicks = createUserSubTickets(database_fns, _allotment, ticketKey, subTickets, registrationId)
      const _ref = createRefPath_event(pathViews, [_globalTicketingName, ticketKey])
      const dataToUpdate = {
        [`userTickets.${registrationId}.allotment`]: currentAllotment,
        [`userTickets.${registrationId}.subTickets`]: subTicks
      }
      database_fns.update_doc(_ref, dataToUpdate, cb)
    }
  }, []);

  return { getTickets, getWillCallTickets, updateTicket, updateAppUserTicket, updating, tickets, allTickets, allTicketsAlt }
}

const getTicketing = (database_fns, pathViews, callback, callbackAlt) => {

  const _refPath = createRefPath_event(pathViews, [_globalTicketingName])

  const cb = (data) => {
    callback(data)
  }

  //   const { refPath, wheres, callback, opts, fs } = props
  // const { listen, altDb } = opts ?? {}

  database_fns.get_data({ refPath: _refPath, callback: cb, opts: { listen: true } }).then(data => {
    callback(data)
    if (_useTicketingSubCollection) {
      if (data) {
        Object.keys(data).forEach(key => {
          const _ticketPaths = createRefPath_event(pathViews, [_globalTicketingName, key, 'userTickets'])
          database_fns.get_data({ refPath: _ticketPaths }).then(sss => {
            const dataC = convertSnapshot(sss, false, { ignoreId: true })
            callbackAlt(dataC, key)
          })
        })
      }
    } else {
      callback(data)
    }
  })
}

const ammendWillCallTicketsByWillCallKey = (state, willCallKey1, willCallKey2, callback) => {

  const { groupedWillCalls, tickets, selectedLookupTicketKey } = state
  const _willCallKeyPathView = willCallKey2 ? willCallKey2 : null
  const _key = _willCallKeyPathView ? _willCallKeyPathView : willCallKey1

  const willCallItem = _key ? groupedWillCalls[_key] : null

  if (willCallItem) {
    const _tickets = getWillCallBy(tickets, willCallItem, _key, _willCallKeyPathView, selectedLookupTicketKey)
    if (callback) {
      callback(_tickets, null, _key)
    } else {
      return _tickets
    }
  } else {
    if (callback) {
      callback(null)
    } else {
      return {}
    }
  }
}

const initUserTicket = (assignedTickets, ticketKey, itemKey) => {
  if (!assignedTickets[ticketKey]) { assignedTickets[ticketKey] = {} }
  if (!assignedTickets[ticketKey].userTickets) { assignedTickets[ticketKey].userTickets = {} }
  if (!assignedTickets[ticketKey].userTickets[itemKey]) { assignedTickets[ticketKey].userTickets[itemKey] = {} }
}

const ticketInfo = (assignedTickets) => {
  if (assignedTickets) {
    Object.keys(assignedTickets).forEach(ticketKey => {
      const assignedTicket = assignedTickets[ticketKey]
      let _allotment = 0
      let entered = 0
      let assignedTo = 0
      let _max = 0
      if (assignedTicket) {
        const { userTickets, status } = assignedTicket ?? {}
        const { max } = status ?? {}
        _max = max
        if (userTickets) {
          Object.keys(userTickets).forEach(userKey => {
            const userTicket = userTickets[userKey]
            if (userTicket) {
              const { allotment, subTickets } = userTicket
              _allotment += parseInt(allotment)
              if (subTickets && _.isArray(subTickets)) {
                subTickets.forEach(subTicket => {
                  const { entered: u, assignedTo: at } = subTicket ?? {}
                  if (u) { entered++ }
                  if (at) { assignedTo++ }
                  subTicket.registrationId = userKey
                })
              }
            }
          })
        }
      }
      assignedTicket.status = {
        allotment: _allotment,
        entered,
        assignedTo,
        max: _max
      }
    })
  }
}

const createUserSubTickets = (database_fns, count, ticketKey, subTicks, registrationId) => {
  if (count && count > 0) {
    let _index = subTicks.length + 1
    const userTickets = []
    for (var i = 1; i <= count; i++) {
      userTickets.push({
        entered: false,
        subTicketKey: database_fns.get_docKey('subTicket'),
        subTicketIndex: _index,
        ticketKey,
        registrationId
      })
      _index++
    }
    return [...subTicks, ...userTickets]
  }
  return []
}